import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { UserInfo } from "../interface/user-info";
import { SecurityService } from "src/app/authentication/service/security.service";
import { UserServiceRoleDTO } from "../interface/user-role-dto";
import { UserDetailsAccessDTO } from "../interface/UserDetailsAccessDTO";
import { UpdateUserDTO } from "../interface/UpdateUserDTO";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private baseUrl: string = environment.apiUrl;

  private serviceId = "";

  constructor(
    private http: HttpClient,
    private security: SecurityService
  ) {}

  getServiceId() {
    return this.security.getServiceId();
  }
  getAllUsers(): Observable<UserDetailsAccessDTO> {
    const serviceId = this.getServiceId();
    return this.http.get<UserDetailsAccessDTO>(`${this.baseUrl}/api/user/service/${serviceId}/users`);
  }

  getMyBuids(serviceId: any): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/api/user/service/${serviceId}/buids`);
  }

  getUserName(): any {
    return this.http.get(`${this.baseUrl}/api/user/username`, {
      responseType: "text",
    });
  }

  getAllRoles(): any {
    return this.http.get(`${this.baseUrl}/roles`);
  }

  updateUser(user: UpdateUserDTO): Observable<any> {
    return this.http.put(`${this.baseUrl}/api/user`, user, {
      responseType: "text",
    });
  }

  updateUserWithTimestamp(user: UpdateUserDTO): Observable<any> {
    return this.http.put(`${this.baseUrl}/api/user?googleSheetAccessRequest=true`, user, { responseType: "text" });
  }

  getServiceRoleDto(): Observable<UserServiceRoleDTO> {
    const serviceId = this.getServiceId();
    return this.http.get<UserServiceRoleDTO>(`${this.baseUrl}/api/user/service/${serviceId}/roles`);
  }
  getUserInfo(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/api/user/service`);
  }

  getAllServices(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/api/user/all-service`);
  }

  deleteUserRole(service: string, userEmail: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/api/user/role/${service}/${userEmail}`, { responseType: "text" });
  }
}
